import { render, staticRenderFns } from "./CmgButton.vue?vue&type=template&id=a4558f22&scoped=true&lang=pug&"
import script from "./cmg-button.ts?vue&type=script&lang=ts&"
export * from "./cmg-button.ts?vue&type=script&lang=ts&"
import style0 from "./CmgButton.vue?vue&type=style&index=0&id=a4558f22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4558f22",
  null
  
)

export default component.exports